<template>
  <AdminMasterLayout>
    <!-- <div class="section__row mt-3" style="margin-bottom: 216px"> -->
    <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
      <div>
        <b-modal
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.confirmingPayment')"
          v-if="status == loading"
        >
          <div
            class="epump-loader"
            style="top: 22%; left: 35%; width: 120px; height: 120px"
          >
            <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
          </div>
        </b-modal>
        <b-modal
          v-if="status == success"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.paymentConfirmed')"
        >
          <div style="margin: 0 auto; width: 43%; margin-top: 80px" class>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          v-if="status == failure"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.errorConfirming')"
        >
          <div style="margin: 0 auto; width: 43%">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              class="cancel_img"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
          </div>
        </b-modal>
      </div>
      <div class="text-center pb-4">
        <p class="page-header">{{ $t("text.iFundWallet.makePayment") }}</p>
      </div>
      <div class="center_div pb-5" style="margin-top: 0px">
        <div class="pad_div">
          <ul class="tabs__lists d-flex justify-content-center">
            <li class="mt-3" @click="changeTab('wallet')">
              <a
                href="#"
                class="tab_link"
                :class="[tab === 'wallet' ? 'active__tab__link' : null]"
              >
                <i
                  class="fa fa-credit-card mr-2"
                  aria-hidden="true"
                  :style="[tab === 'wallet' ? { color: '#370F70' } : null]"
                ></i>
                {{ $t("text.iFundWallet.bankTransfer") }}
              </a>
            </li>
            <li class="mt-3 ml-1" @click="changeTab('card')">
              <a
                href="#"
                class="tab_link"
                :class="[tab === 'card' ? 'active__tab__link' : null]"
              >
                <i
                  class="fa fa-credit-card mr-2"
                  aria-hidden="true"
                  :style="[tab === 'card' ? { color: '#370F70' } : null]"
                ></i>
                {{ $t("text.iFundWallet.card") }}
              </a>
            </li>
            <!-- <li class="mt-3 ml-5" @click="changeTab('deposit')">
              <a
                href="#"
                class="tab_link"
                :class="[tab === 'deposit' ? 'active__tab__link' : null]"
              >
                <i
                  class="fa fa-credit-card mr-2"
                  aria-hidden="true"
                  :style="[tab === 'deposit' ? { color: '#370F70' } : null]"
                ></i>
                Bank Deposit
              </a>
            </li> -->
          </ul>
        </div>
        <div v-if="tab === 'card'">
          <div class="pay_header text-center">
            {{ $t("text.iFundWallet.fundAccountWithCard") }}
          </div>
          <div class="text-center mt-4">
            <img src="@/assets/img/credit-card.svg" width="35px" />
          </div>
          <div class="text-center mt-4">
            <small class="small_text"></small>
          </div>
          <div class="input_holder">
            <div class="mt-4">
              <input type="hidden" class="email" />
              <input type="hidden" class="phone" />
              <input type="hidden" class="publicKey" />
              <input type="hidden" name="trxRef" class="trxRef" />
              <input type="hidden" name="flwRef" class="flwRef" />
              <input
                type="number"
                name="amount"
                class="form-control form__input amount"
                :placeholder="$t('text.iFundWallet.amount')"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="mt-4 text-center">
            <button class="ep-btn ep-primary" @click="payFunction($event)">
              {{ $t("text.iFundWallet.payNow") }}
            </button>
          </div>
        </div>

        <div v-if="tab === 'wallet'">
          <div class="pay_header text-center">
            {{ $t("text.iFundWallet.desc") }}
          </div>
          <div class="text-center mt-4">
            <img src="@/assets/img/money (3).svg" width="50" />
          </div>

          <!-- <div class="mx-auto text-center" style="width: 500px"> -->
          <div class="mx-auto text-center p-2">
            <ul class="mt-3 list-group">
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.iFundWallet.bankName") }}
                <span class="text-secondary">{{
                  $t("text.iFundWallet.providusBank")
                }}</span>
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.iFundWallet.accountNumber") }}
                <span class="text-secondary">{{ this.accountNumber }}</span>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="20px"
                  class="ml-3 loader4"
                />
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span class="text-left">{{
                  $t("text.iFundWallet.accountName")
                }}</span>
                <!-- {{ $t("text.iFundWallet.accountName") }} -->
                <span class="text-secondary text-right">
                  {{ this.accountName }}</span
                >
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="20px"
                  class="ml-3 loader4"
                />
              </li>
              <li
                v-if="$route.query.amt"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.cInvoice.amountDue") }}
                <span class="text-secondary">
                  {{ walletUnit }}{{ this.$route.query.amt }}</span
                >
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.cWallet.walletBalance") }}:
                <span class="text-secondary">
                  <span
                    :style="[
                      displayAmt ? { display: 'none' } : { display: 'inline' },
                    ]"
                  >
                    {{ walletUnit }}{{ convertThousand(walletBalance) }}
                    <i
                      class="ml-2 cursor-pointer fa fa-refresh"
                      style="font-size: 15px; color: grey"
                      :style="[
                        isButtonDisabled
                          ? { cursor: 'not-allowed' }
                          : { cursor: 'pointer' },
                      ]"
                      aria-hidden="true"
                      v-b-tooltip.hover
                      :title="$t('text.clickButtons.refresh')"
                      @click="getWalletBalance"
                    ></i>
                  </span>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="20px"
                    class="ml-3 loader3"
                /></span>
              </li>
              <p v-if="$route.query.id" class="font-weight-light mt-3">
                {{ $t("text.iFundWallet.desc2") }}
              </p>
              <p v-else class="font-weight-light mt-3">
                {{ $t("text.iFundWallet.desc3") }}
                {{ $t("text.iFundWallet.clickContinue") }}
              </p>

              <button
                v-if="$route.query.id"
                class="ep-btn ep-primary"
                @click="continuePaz"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                <span
                  :style="[
                    displayTxt ? { display: 'none' } : { display: 'inline' },
                  ]"
                  >{{ $t("text.cInvoice.settleInvoice") }}</span
                >
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="22px"
                  class="ml-3 loader"
                />
              </button>
              <button v-else class="ep-btn ep-primary" @click="continuePay">
                {{ $t("text.iFundWallet.continue") }}
              </button>
              <!-- <button class="btn btn_theme mt-3" @click="maked">
                Continue
              </button> -->
            </ul>
          </div>
        </div>
        <!-- <div class="" v-if="tab === 'deposit'">
          <div class="p-3">
            <div class="pay_header text-center">
              Fill the form below to fund your account through bank deposit
            </div>
            <div class="text-center mt-4">
              <img src="@/assets/img/money (3).svg" width="50" />
            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <label>Account</label>
                <select type="text" placeholder="" v-model="abankName">
                  <option value="selectAccount" selected disabled>
                    Select Account
                  </option>
                  <option
                    :value="bank.bankName"
                    v-for="(bank, i) in banks"
                    :key="i"
                  >
                    {{ bank.accountName }} ({{ bank.accountNumber }})
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Bank </label>
                <input
                  type="text"
                  placeholder=""
                  v-model="abankName"
                  disabled
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <label>Depositor''s name</label>
                <input type="text" placeholder="" v-model="depositorName" />
              </div>
              <div class="col-md-6">
                <label>Deposit slip number</label>
                <input type="text" placeholder="" v-model="depositSlipNo" />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <label>Amount</label>
                <input type="text" placeholder="" v-model="amountPaid" />
              </div>
              <div class="col-md-6">
                <label>Date paid</label>
                <vue-ctk-date-time-picker
                  :max-date="maxDate"
                  v-model="datePaid"
                  :onlyDate="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  label="Select date paid"
                />
              </div>
            </div>
          </div>
      
          <div class="text-center mt-4">
            <button
              class="ep-btn ep-primary"
              @click="payViaBankDeposit"
              :disabled="isButtonDisabled ? true : false"
              style="border: 0"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
            >
              Request to fund

              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="20px"
                class="ml-3 loader2"
              />
            </button>
          </div>
        </div> -->

        <div
          class="pattern_sec"
          :style="[
            {
              zIndex: '-1200',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundImage: `linear-gradient(rgb(55, 15, 112 , 0.001), rgb(55, 15, 112 ,0.001)), url(${backImg})`,
            },
          ]"
        ></div>
      </div>
    </div>
  </AdminMasterLayout>
</template>

<script>
import Vue from "vue";
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import configObject from "@/config";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Make Payment:: Epump Portal",
  name: "MakePayment",
  components: {
    AdminMasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      backImg,
      tab: "wallet",
      loading: 0,
      paymentConfirmed: null,
      success: 1,
      failure: 2,
      status: 0,
      backgroundUrl,
      modalWidth: null,
      modalheight: null,
      showBanner: true,
      payOnline: true,
      email: "",
      phone: "",
      publicKey: "",
      banks: null,
      amount: null,
      depositNo: null,
      depositorName: null,
      bank: null,
      showdropDown: false,
      accountNumber: null,
      toggleBanksDropdown: false,
      isButtonDisabled: false,
      showButtonLoader: true,
      flwRef: "",
      trxRef: "",
      reservedAccount: null,
      accountName: null,
      accountNumber: null,
      bankName: null,
      company: null,
      companyID: null,
      invoiceId: null,
      fundingAmount: null,
      depositorName: null,
      amountPaid: 0,
      depositorName: "",
      abankName: "selectAccount",
      referralCode: "",
      depositSlipNo: "",
      datePaid: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      walletBalance: 0,
      walletUnit: "",
      displayAmt: false,
      displayTxt: false,
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyID = this.$route.query.companyID
        ? this.$route.query.companyID
        : this.company.id;
      this.invoiceId = this.$route.query.id;
      this.getFundProperties();
      this.getAccountDetails();
      this.getWalletBalance();
    });
  },
  beforeDestroy() {},
  mounted() {
    // this.showModal();
    // this.status = this.failure;
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getFundProperties();
        this.getAccountDetails();
      }
    },
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    // maked() {
    //   this.$router.push("/Industrial/Branch/Dashboard");
    // },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    generateTransactionRef() {
      var allString = "0123456789";
      var rString = "EP" + this.randomString(14, allString);
      return rString;
    },

    continuePaz() {
      const confirm = window.confirm(
        `Do you want to settle Invoice of ${this.$route.query.amt}?`
      );
      if (!confirm) {
        return;
      }
      $(".loader").show();
      this.isButtonDisabled = true;
      this.displayAmt = true;

      const data = {
        invoiceId: this.$route.query.id,
        amountPaid: this.$route.query.amt,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Invoices/settle-invoice-payment`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text.invoicesModal.paymentSuccessful"),
            type: "success",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.displayAmt = false;
          this.$router.push({
            name: "industrial_admin_invoice_details",
            query: { id: this.invoiceId, companyID: this.companyID },
          });
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.displayAmt = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    directInvoiceSettlement() {
      const data = {
        invoiceId: this.$route.query.id,
        amountPaid: this.$route.query.amt,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Invoices/settle-invoice-payment`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text.invoicesModal.paymentSuccessful"),
            type: "success",
            duration: 3000,
          });
          setTimeout(this.rerouteToID, 4000);
          // this.$router.push({
          //   name: "invoice_details",
          //   query: { id: this.invoiceId, companyID: this.companyID },
          // });
        })
        .catch((error) => {
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    rerouteToID() {
      this.$router.push({
        name: "industrial_admin_invoice_details",
        query: { id: this.invoiceId, companyID: this.companyID },
      });
    },
    getWalletBalance() {
      $(".loader3").show();
      this.isButtonDisabled = true;
      this.displayAmt = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/WalletBalanceForCompany/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          $(".loader3").hide();
          this.isButtonDisabled = false;
          this.displayAmt = false;
          this.walletBalance = response.data.walletBalance;
          this.walletUnit = response.data.walletUnit;
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    walletPayment($event) {
      $event.preventDefault();
      if (!this.fundingAmount) {
        this.$toast.open({
          message: this.$t("text.iFundWallet.amountMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        branchId: this.companyID,
        amount: parseFloat(this.fundingAmount),
        paymentMode: "UserWallet",
      };
      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/FundWallet`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t("text.iFundWallet.paymentConfirmed"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.status = this.failure;
          this.showModal();
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    getFundProperties() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Wallet/FundProperties`;
        this.axios
          .get(url, configObject.authConfig())
          .then((response) => {
            let user = JSON.parse(localStorage.getItem("userDetails"));
            this.showBtnLoader = false;
            this.email = user.email;
            this.phone = user.phone;
            this.publicKey = response.data.publicKey;
            this.referralCode = response.data.referralCode;
            this.banks = response.data.banks;
            // this.accountName = response.data.accountName;
            // this.bankName = response.data.bankName;
          })
          .catch((error) => {});
      }
    },

    getAccountDetails() {
      $(".loader4").show();
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Wallet/GetCompanyBankDetails?id=${this.companyID}`;
        this.axios
          .get(url, configObject.authConfig())
          .then((res) => {
            // console.log(res.data.accountName)
            this.accountName = res.data.accountName;
            this.accountNumber = res.data.reservedAccount;
            $(".loader4").hide();
            //this.banks = response.data.banks;
            //this.walletBalance = this.convertThousand(res.data.balance);
          })
          .catch((error) => {});
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    confirmPayment() {
      this.showModal();
      this.status = this.loading;
      let data = {
        companyId: this.companyID,
        amount: parseFloat(this.amount),
        paymentMode: "rave",
        trxRef: this.trxRef,
        flw: true,
        flwRef: this.flwRef,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/FundWalletOnline`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          // this.showModal();
          this.$toast.open({
            message: this.$t("text.iFundWallet.paymentConfirmed"),
            type: "success",
            duration: 5000,
          });
          if (
            this.$route.query.id &&
            this.$route.query.amt &&
            parseFloat(this.amount) >= this.$route.query.amt
          ) {
            // console.log("settling direct invoice");
            this.directInvoiceSettlement();
          } else {
            setTimeout(this.routeToComWallet, 3000);
          }
        })
        .catch((error) => {
          this.status = this.failure;
        });
    },
    routeToComWallet() {
      this.$router.push({
        name: "industrial_admin_wallet",
        query: { companyID: this.companyID },
      });
    },
    // payViaBankDeposit(e) {
    //   e.preventDefault();
    //   if (this.abankName == "selectAccount") {
    //     this.$toast.open({
    //       message: "Select an Account",
    //       type: "error",
    //       duration: 3000,
    //     });
    //     return;
    //   }
    //   if (!this.depositorName) {
    //     this.$toast.open({
    //       message: "Depositior's name is required",
    //       type: "error",
    //       duration: 3000,
    //     });
    //     return;
    //   }
    //   if (!this.depositSlipNo) {
    //     this.$toast.open({
    //       message: "Deposit slip number is required",
    //       type: "error",
    //       duration: 3000,
    //     });
    //     return;
    //   }

    //   if (!this.amountPaid) {
    //     this.$toast.open({
    //       message: "Amoun paid is required",
    //       type: "error",
    //       duration: 3000,
    //     });
    //     return;
    //   }

    //   let data = {
    //     bankName: this.abankName,
    //     amountPaid: parseFloat(this.amountPaid),
    //     depositorName: this.depositorName,
    //     depositSlipNo: this.depositSlipNo,
    //     datePaid: this.datePaid,
    //     referralCode: this.referralCode,
    //     corpId: this.$route.query.companyId,
    //   };

    //   this.isButtonDisabled = true;
    //   $(".loader2").show();
    //   this.axios
    //     .post(
    //       `${configObject.apiBaseUrl}/Wallet/RequestToFund`,
    //       data,
    //       configObject.authConfig()
    //     )
    //     .then(() => {
    //       this.isButtonDisabled = false;
    //       $(".loader2").hide();
    //       this.$toast.open({
    //         message: "Funds requested successfully",
    //         type: "success",
    //         duration: 3000,
    //       });
    //     })
    //     .catch((error) => {
    //       this.isButtonDisabled = false;
    //       $(".loader2").hide();
    //     });
    // },
    payFunction(event) {
      event.preventDefault();
      $(".email").val(this.email);
      $(".phone").val(this.phone);
      $(".publicKey").val(this.publicKey);
      var btn = $(this);
      btn.attr("disabled", "disabled");
      var realAmt = parseFloat($(".amount").val());
      if (isFinite(realAmt) && realAmt > 0) {
        //var amt = realAmt + (realAmt * (1.6 / 100));

        var email = $(".email").val();
        var phone = $(".phone").val();
        var pk = $(".publicKey").val(); //"FLWPUBK-fc08788826e348423d0d89eb1370f784-X";//
        var allString = "0123456789";
        var PBFKey = pk;
        var rString = "EP" + this.randomString(14, allString);
        let _this = this;
        // eslint-disable-next-line no-undef
        let raveSetup = getpaidSetup({
          PBFPubKey: PBFKey,
          customer_email: email,
          customer_firstname: "",
          customer_lastname: "",
          custom_description: "Fund Wallet",
          custom_logo:
            "https://app.epump.com.ng/Content_v3/Images/e-pump%20logo2.png",
          custom_title: "EPump",
          amount: realAmt,
          customer_phone: phone,
          country: "NG",
          currency: "NGN",
          payment_method: "both",
          txref: rString,
          //integrity_hash: "<ADD YOUR INTEGRITY HASH HERE>",

          callback: function (response) {
            // console.log("callback initiated");
            // console.log(response);
            var tx_Ref = response.tx.txRef;
            var flw_Ref = response.tx.flwRef;
            // collect flwRef returned and pass to a server page to complete status check.

            if (response.tx.chargeResponseCode == "00") {
              _this.trxRef = tx_Ref;
              _this.flwRef = flw_Ref;
              _this.amount = realAmt.toString();
              //_this.closeModal();
              _this.confirmPayment();
              // $('.trxRef').val(response.tx.txRef);
              // $('.flwRef').val(flw_ref);
              //$('.onlinePay').submit();
              // redirect to a success page
            } else {
              // redirect to a failure page.
            }
            raveSetup.close();
            // to settle invoice automatically
          },
          onclose: function () {
            btn.removeAttr("disabled");
          },
        });
      } else {
        this.$toast.open({
          message: this.$t("text.iFundWallet.amountMissing"),
          type: "error",
          duration: 10000,
        });
        btn.removeAttr("disabled");
      }
    },
  },
};
</script>
